<template>
  <div class="main-layout main-layout_fullpage">
    <div class="main-layout__head main-layout__head_pb24">
      <h2 class="main-title">Angebot &amp; Arbeitsschein</h2>
    </div>

    <pdf-list />

    <add-btn @onClick="openPdfFile" />

    <modal :show="isShowModal" :dark="true" :outside="false" @close="closePdfModal">
      <transition name="showmodal">
        <pdf-modal @close="closePdfModal" @done="done" />
      </transition>
    </modal>
  </div>
</template>

<script>
import addBtn from '@/components/controls/addBtn'
import pdfModal from '@/components/modals/pdf/pdfModal'
import pdfList from '@/components/lists/pdf/pdfList'
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
    components: {
        addBtn,
        pdfModal,
        pdfList,
    },
    // data() {
    //   return {
    //     isShowModal: false,
    //   };
    // },
    computed: {
        ...mapGetters({
            isShowModal: 'pdf/isShowModal',
        }),
    },
    methods: {
        ...mapActions({
            fetch: 'pdf/fetch',
        }),
        ...mapMutations({
            setState: 'pdf/setState',
        }),
        closePdfModal() {
            this.setState({
                key: 'isShowModal',
                data: false,
            })
        },
        openPdfFile() {
            this.setState({
                key: 'isShowModal',
                data: true,
            })
        },
        async done() {
            await this.fetch()
            this.closePdfModal()
        },
    },
    created() {
        this.fetch()
    },
}
</script>
